module.exports = __webpack_public_path__ + "img/gain.4cc5ddae.png";